export const FETCH_ALL_OFFERS_REQUESTED = 'FETCH_ALL_OFFERS_REQUESTED';
export const FETCH_ALL_OFFERS_SUCCESSED = 'FETCH_ALL_OFFERS_SUCCESSED';
export const FETCH_OFFER_DETAIL_REQUESTED = 'FETCH_OFFER_DETAIL_REQUESTED';
export const FETCH_OFFER_DETAIL_SUCCESSED = 'FETCH_OFFER_DETAIL_SUCCESSED';
export const REMOVE_OFFER_REQUESTED = 'REMOVE_OFFER_REQUESTED';
export const REMOVE_OFFER_SUCCESSED = 'REMOVE_OFFER_SUCCESSED';
export const GET_ALL_PRODUCTS_REQUESTED = 'GET_ALL_PRODUCTS_REQUESTED';
export const GET_ALL_PRODUCTS_SUCCESSED = 'GET_ALL_PRODUCTS_SUCCESSED';
export const CREATE_OFFER_REQUESTED = 'CREATE_OFFER_REQUESTED';
export const CREATE_OFFER_SUCCESSED = 'CREATE_OFFER_SUCCESSED';
export const UPDATE_OFFER_REQUESTED = 'UPDATE_OFFER_REQUESTED';
export const UPDATE_OFFER_SUCCESSED = 'UPDATE_OFFER_SUCCESSED';
